import { ComponentProps } from 'react';
import { FormattedMessage as ReactIntlFormattedMessage } from 'react-intl';
import { TranslationKey, translationKeyToString } from 'intl/types/translationKey';
type TypedFormattedMessageProps = Omit<
  ComponentProps<typeof ReactIntlFormattedMessage>,
  'id'
> & {
  id: TranslationKey;
};

export function TypedFormattedMessage(
  props: TypedFormattedMessageProps
): JSX.Element {
  return (
    <ReactIntlFormattedMessage {...props} id={translationKeyToString(props.id)} />
  );
}

/** Preferred typed wrapper over react-intl FormattedMessage. */
export { TypedFormattedMessage as FormattedMessage };
